/**
 * Fecha. Se muestra y se edita en dd/mm/aaaa, siempre, gane lo que gane el locale
 * del sistema operativo.
 *
 * Antes usaba el `<input type="date">` nativo, que dibuja la fecha segun el SO: en
 * una maquina en ingles salia mm/dd/aaaa y gritaba «software importado». Ahora la
 * edicion la resuelve `DatePickerInput` (texto dd/mm/aaaa + popup del calendario
 * nativo), y el valor sigue viajando como `YYYY-MM-DD` sin pasar nunca por `Date`,
 * para que una fecha de vencimiento no se corra un dia al cruzar la medianoche en
 * otra zona horaria.
 */

import { DatePickerInput } from '@/components/fields/DatePickerInput';
import { ReadonlyOutput } from '@/components/fields/FieldDisplay';
import type { FieldInputProps } from '@/components/fields/types';

export function DateField({
  id,
  meta,
  value,
  onChange,
  readonly,
  required,
  invalid,
  describedBy,
}: FieldInputProps) {
  if (readonly) {
    return <ReadonlyOutput id={id} meta={meta} value={value} {...(describedBy === undefined ? {} : { describedBy })} />;
  }

  return (
    <DatePickerInput
      id={id}
      value={typeof value === 'string' ? value : ''}
      onChange={onChange}
      invalid={invalid}
      required={required}
      {...(describedBy === undefined ? {} : { describedBy })}
    />
  );
}
